"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightsSectionHeader = exports.MoreTooltipContent = exports.FilterMatchClearButton = exports.CheckMark = exports.CheckmarkContainer = exports.CardContentText = exports.CardContentAnchor = exports.CardContentHorizontalListItem = exports.CardContentHorizontalList = exports.CardContentHeader = exports.CardContentContainer = exports.ProviderAffiliationsCard = exports.ProviderInformationCard = exports.CardsContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Check_1 = __importDefault(require("@kyruus/react-ikons/Check"));
const constants_1 = require("../../lib/constants");
const dot_spacer_styles_1 = require("../../lib/styles/dot-spacer.styles");
const infoCardsColumnGap = (0, ui_theme_1.fromTheme)('spacing_large');
exports.CardsContainer = styled_1.default.div `
  display: flex;
  flex-flow: row wrap;
  row-gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  column-gap: ${infoCardsColumnGap};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  width: 100%;

  @media only screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    width: calc(100% + ${infoCardsColumnGap});
  }
`;
exports.ProviderInformationCard = styled_1.default.div `
  position: relative;
  flex: 1 1 100%;
  max-width: 100%;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  padding: 0;

  @media only screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    flex: 1 1 calc(50% - ${infoCardsColumnGap});
    max-width: calc(50% - ${infoCardsColumnGap});
  }
`;
exports.ProviderAffiliationsCard = (0, styled_1.default)(exports.ProviderInformationCard) `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};

  @media only screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    max-width: 100%;
  }
`;
exports.CardContentContainer = styled_1.default.div `
  overflow: hidden;
  // This padding value is to fix letter and outline cutting from bottom inside the container
  padding: 3px;
`;
exports.CardContentHeader = styled_1.default.h4 `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
const cardContentListColumnGap = (0, ui_theme_1.fromTheme)('spacing_xsmall');
exports.CardContentHorizontalList = styled_1.default.ul `
  margin: 0;
  padding: 0;

  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.CardContentHorizontalListItem = styled_1.default.li `
  display: inline-block;
  list-style: none;
  margin: 0 ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} 0;
  padding: 0;

  & + li:before {
    ${(props) => (0, dot_spacer_styles_1.dotSpacer)({
    marginLeft: 'initial',
    marginRight: cardContentListColumnGap(props)
})}
  }
`;
exports.CardContentAnchor = styled_1.default.a `
  text-decoration: none;
  color: ${(0, ui_theme_1.fromTheme)('color_info')};

  &:hover {
    text-decoration: underline;
  }

  @media print {
    display: none;
  }
`;
exports.CardContentText = styled_1.default.span `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.CheckmarkContainer = styled_1.default.span `
  position: absolute;
  top: -1rem;
  right: -1rem;
  color: #00cfb5;
`;
exports.CheckMark = (0, styled_1.default)(Check_1.default) `
  position: absolute;
  // these styles need overriding in order to render correctly in PMC (https://kyruus.jira.com/browse/KENG-34177)
  left: 6px;
  top: 7px;
  color: ${(0, ui_theme_1.fromTheme)('color_background')};
`;
exports.FilterMatchClearButton = styled_1.default.button `
  background: none;
  border: none;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
  color: ${(0, ui_theme_1.fromTheme)('color_info')};
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }

  @media print {
    display: none;
  }
`;
exports.MoreTooltipContent = styled_1.default.span `
  border-bottom: 1px dotted;
  display: inline-block;
  padding-bottom: 1px;

  &:hover {
    cursor: pointer;
  }
`;
exports.HighlightsSectionHeader = styled_1.default.h2 `
  margin: 0;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
`;
//# sourceMappingURL=styles.js.map